import { render, staticRenderFns } from "./LawyerAuthority.vue?vue&type=template&id=cc45ee9c&scoped=true"
import script from "./LawyerAuthority.vue?vue&type=script&lang=js"
export * from "./LawyerAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc45ee9c",
  null
  
)

export default component.exports